import { DefaultState, DropdownItem } from 'store/types';
import { Filters } from 'store/types';

export const GET_ADDRESSES_FOR_FILTER_REQUEST = 'GET_ADDRESSES_FOR_FILTER_REQUEST';
export const GET_ADDRESSES_FOR_FILTER_SUCCESS = 'GET_ADDRESSES_FOR_FILTER_SUCCESS';
export const GET_ADDRESSES_FOR_FILTER_FAILURE = 'GET_ADDRESSES_FOR_FILTER_FAILURE';

export interface GetAddressesForFilterParams {
  filters: Filters;
  paging: {
    page: number;
    pageSize: number;
  };
};

export interface GetAddressesForFilterData {
  rows: DropdownItem[];
  totalCount: number;
}

export type GetAddressesForFilterState = DefaultState & {
  contents?: GetAddressesForFilterData;
};

interface ReadGetAddressesForFilterRequest {
  type: typeof GET_ADDRESSES_FOR_FILTER_REQUEST;
};

interface ReadGetAddressesForFilterSuccess {
  type: typeof GET_ADDRESSES_FOR_FILTER_SUCCESS,
  contents: GetAddressesForFilterData;
}

interface ReadGetAddressesForFilterFailure {
  type: typeof GET_ADDRESSES_FOR_FILTER_FAILURE;
}

export type GetAddressesForFilterActionTypes = ReadGetAddressesForFilterRequest | ReadGetAddressesForFilterSuccess | ReadGetAddressesForFilterFailure;
